import { createProvider } from '@nvision/services/data-provider';

import type { ShipTypeFilters } from '../../models';
import * as api from './api';
import { normalizeShipTypeFilters, normalizeShipTypes } from './normalize';

export const fetchShipTypes = createProvider(
  (filters: Partial<ShipTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchShipTypes(normalizeShipTypeFilters(filters), { signal }),
).andThen((res) => normalizeShipTypes(res));
